export enum LocationSource {
  Unknown = 0,
  Automatic = 10,
  Address = 20,
  Manual = 30,
  Reviewed = 40,
  USCensus = 50,
  USGS = 51,
  ReportAll = 100,
  CompanyWebsite = 200
}

export const LocationSourceMapping: Record<LocationSource, string> = {
  [LocationSource.Unknown]: 'Unknown',
  [LocationSource.Automatic]: 'Automatic',
  [LocationSource.Address]: 'Address',
  [LocationSource.Manual]: 'Manual',
  [LocationSource.Reviewed]: 'Reviewed',
  [LocationSource.USCensus]: 'US Census',
  [LocationSource.USGS]: 'US GS',
  [LocationSource.ReportAll]: 'Report All',
  [LocationSource.CompanyWebsite]: 'Company Website'
};
